// hooks/usePersistentDateRange.js
import { useState } from 'react';
import formatDateDDMMYYYY from '../../../utils/formatDate';
import {
  startOfWeek,
  endOfWeek,
  isValid
} from 'date-fns';

const usePersistentDateRange = (storageKey = 'dashboard_date_range') => {
  const [selectedRange, setSelectedRange] = useState(() => {
    try {
      const saved = localStorage.getItem(storageKey);

      if (saved) {
        const parsed = JSON.parse(saved);

        // Valid saved range
        if (
          Array.isArray(parsed) &&
          parsed.length > 0 &&
          parsed[0]?.startDate &&
          parsed[0]?.endDate
        ) {
          return parsed.map((range) => ({
            ...range,
            startDate: new Date(range.startDate),
            endDate: new Date(range.endDate),
          }));
        }
      }

      // Fallback to current week (Mon–Sun)
      // const maxDateStr = localStorage.getItem('max_date');
      // const today = maxDateStr ? new Date(maxDateStr) : new Date();

      // const weekStart = startOfWeek(today, { weekStartsOn: 1 }); // Monday
      // const weekEnd = endOfWeek(today, { weekStartsOn: 1 });     // Sunday

      // return [
      //   {
      //     startDate: weekStart,
      //     endDate: weekEnd,
      //     key: 'selection',
      //   },
      // ];
    } catch (err) {
      console.error('Failed to load or parse saved date range:', err);

      // Fallback to today if everything else fails
      // const today = new Date();
      // return [
      //   {
      //     startDate: today,
      //     endDate: today,
      //     key: 'selection',
      //   },
      // ];
    }
  });

  const handleDateChange = (range) => {
    setSelectedRange(range);
    localStorage.setItem(storageKey, JSON.stringify(range));
  };

  // Safe destructuring with fallback
  const startDate = isValid(selectedRange?.[0]?.startDate)
    ? selectedRange[0].startDate
    : new Date();

  const endDate = isValid(selectedRange?.[0]?.endDate)
    ? selectedRange[0].endDate
    : new Date();

  const formattedStart = formatDateDDMMYYYY(startDate);
  const formattedEnd = formatDateDDMMYYYY(endDate);

  return {
    selectedRange,
    handleDateChange,
    formattedStart,
    formattedEnd,
    startDate,
    endDate,
  };
};

export default usePersistentDateRange;
